
import { TableColumnType } from 'antd'
import moment from 'moment'
import React, { useRef } from 'react'

export const YBJSSJColumns = (
  isClassifiedByDiseaseChecked?: any,
): TableColumnType<any>[] => {

  const column: TableColumnType<any>[] = [
    {
      title: '序号',
      key: 'no',
      width: '4rem',
      align: 'center',
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: '主要诊断',
      dataIndex: 'mainDisease',
      width: '14rem',
      align: 'left',
      ellipsis: true,
      key: 'mainDisease',
      render: (_, r) => {
        return r?.mainDisease || '-'
      },
    },
    {
      title: '商品信息',
      width: '14rem',
      dataIndex: 'productInfo',
      align: 'left',
      ellipsis: true,
      key: 'productInfo',
      render: (_, r) => {
        return r?.productInfo || '-'
      },
    },
    {
      title: '总数量',
      dataIndex: 'cnt',
      width: '6rem',
      align: 'center',
      key: 'cnt',
      render: (_, r) => {
        return r?.cnt || 0
      },
    },

  ]

  return isClassifiedByDiseaseChecked ? column : column?.filter((item) => item.key != 'mainDisease')
}

